import { useEffect } from "react";
import "../styles/components/Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faLightbulb,
  faPhone,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../hooks/LanguageContext";

function Sidebar({ isSidebarVisible, toggleSidebar, isMobile }) {
  const { isEnglish } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      toggleSidebar();
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = isSidebarVisible ? "hidden" : "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSidebarVisible, isMobile]);

  const links = [
    { path: "/", label: isEnglish ? "Home" : "Inicio", icon: faHome },
    {
      path: "/projects",
      label: isEnglish ? "Projects" : "Proyectos",
      icon: faLightbulb,
    },
    {
      path: "/about",
      label: isEnglish ? "About Me" : "Sobre mí",
      icon: faUser,
    },
    {
      path: "/contact",
      label: isEnglish ? "Contact Me" : "Contáctame",
      icon: faPhone,
    },
  ];

  return (
    <aside
      className={`sidebar ${isSidebarVisible ? "show" : "hidden"}`}
      aria-hidden={isMobile && !isSidebarVisible}
    >
      {isMobile && isSidebarVisible && (
        <button
          type="button"
          className="close-btn"
          onClick={toggleSidebar}
          aria-label={isEnglish ? "Close menu" : "Cerrar menú"}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}

      <img
        src="LOGO_BLANCO.png"
        alt="Logo"
        className="logo"
        onClick={() => handleNavigation("/")}
      />
      <h2 className="sidebar-name" onClick={() => handleNavigation("/")}>
        Miguel Olteanu
      </h2>
      <p className="sidebar-description">
        {isEnglish ? "Software Engineer" : "Ingeniero de Software"}
      </p>

      <nav className="sidebar-nav" aria-label="Main">
        {links.map((link) => (
          <button
            key={link.path}
            type="button"
            className={`button ${
              location.pathname === link.path ? "active" : ""
            }`}
            onClick={() => handleNavigation(link.path)}
          >
            <FontAwesomeIcon icon={link.icon} className="icon" />
            {link.label}
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
